import { useEffect, useRef } from 'react';
import { useOnlineStatus } from 'hooks/useOnlineStatus';
import { flushPendingDrafts } from 'services/offlineMantencionSync';
import { flushPendingCierres } from 'services/offlineCierreSync';
import { refreshSolicitudesCache } from 'services/prefetchMantencionesIniciadas';
import { refreshMisTareasCache } from 'services/prefetchMisTareas';

// Daemon de sync en segundo plano. Se monta UNA vez (SecureRouter) y sobrevive
// la navegación. Sube todos los drafts pendientes al volver la conexión (o al
// montar estando online), sin importar en qué página esté el técnico. Al terminar
// los drafts, sube los cierres encolados (que dependen de que el checklist ya
// esté sincronizado). Cierra el gap de la v1 (que solo auto-sincroniza la
// mantención abierta).
export function useOfflineSyncDaemon() {
  const isOnline = useOnlineStatus();
  // Arranca en false a propósito: así si monta estando online, flushea una vez.
  const wasOnlineRef = useRef(false);

  useEffect(() => {
    const cameOnline = !wasOnlineRef.current && isOnline;
    wasOnlineRef.current = isOnline;
    if (cameOnline) {
      // Primero el checklist (PUT), luego el cierre (finish + envío), que
      // depende de que el draft ya esté sincronizado.
      flushPendingDrafts()
        .catch(() => {})
        .then(() => flushPendingCierres())
        .catch(() => {})
        .then(() => refreshSolicitudesCache())
        .catch(() => {})
        .then(() => refreshMisTareasCache())
        .catch(() => {});
    }
  }, [isOnline]);
}
